import React, { Fragment, useContext, useState } from 'react'
import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import { BsCalendar } from "@react-icons/all-files/bs/BsCalendar";
import { FaPeopleGroup } from 'react-icons/fa6';
import { FaRegCircle } from 'react-icons/fa';
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io'
import { MdNotificationsNone, MdTipsAndUpdates, MdKeyboardArrowRight, MdCalendarMonth } from 'react-icons/md';
import { IoDocumentTextOutline, IoIosDocument, IoMdArrowDropdown } from 'react-icons/io';
import { FaHandshake, FaPlus } from 'react-icons/fa';
import { AiOutlineQuestionCircle, AiFillFolder, AiFillFile, AiOutlineCloseCircle, AiOutlineSearch } from 'react-icons/ai'
import { SiHandshake } from 'react-icons/si'
import { BiEdit } from 'react-icons/bi'
import Renderif from '../../components/renderif';
import SideMenu from '../../components/sidemenu';
import CheckBox from '../../components/checkbox';
import DropDown, { DropDownOption } from '../../components/dropdown';
import BVCalendar from '../../components/calendar';
import { gray30, gray40, primary } from '../../utils/colors';
import Slider from '../../components/slider';
import AgendarCitaFamiliar from './agendar_familia_client';
import { Await, useNavigate } from 'react-router-dom';
import { Service } from '../../services/api';
import { AlertContext } from '../../context/alert_context';
import AgendarCita from './agendar_client';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { GoGear } from 'react-icons/go';
import { CgProfile, CgLogOut, CgHashtag } from 'react-icons/cg';
import { AuthContext } from '../../context/auth_context';





export default function PreciosClient() {
    const { user, logout } = useContext(AuthContext)
    const { notify } = useContext(AlertContext)
    const navigate = useNavigate()

    const [state, setState] = useState({
        showCheckOut: false,
        rederedCheckOut: false,
        planes: []

    })
    // price_1OldPKIYbD4YUdkZUIZc2dmg
    useState(() => {
        const init = async () => {
            const queryString = window.location.search;

            const urlParams = new URLSearchParams(queryString);


            if (urlParams.get('session_id')) {
                notify({ title: 'Suscripción', message: 'Tu pago se ha procesado exitosamente.¡Continúa explorando BienVivir!', type: 'success' })
            }

            let _planes = await Service('GET', 'PaymentGateway/plans');
            setState({ ...state, planes: _planes.data })
            console.log(_planes)

        };
        init();
        return () => { }
    }, [])

    const CheckOut = async (plan_id) => {
        let body = {
            plan_id: state.planes[plan_id].id
        }
        let _checkout = await Service('POST', 'PaymentGateway/create-checkout-session', body);
        console.log(_checkout)
        if (_checkout.status === 200) {
            console.log(_checkout);
            window.open(_checkout.data.url, '_blank')
        } else {
            notify({ title: 'Suscripción', message: 'Por el momento no puedes suscribirte a este plan', type: 'error' })
        }
    }

    // "https://bienvivirapp.com/success?session_id={CHECKOUT_SESSION_ID}"
    const tokenizer = () => {
        if (!state.rederedCheckOut) {
            const config = {
                targetIFrame: "#conektaIframeContainer",
                publicKey: "key_AbT0mhS15DDsrbUvKmXQxNa", // Llaves: https://developers.conekta.com/docs/como-obtener-tus-api-keys
                locale: 'es', // 'es' Español | 'en' Ingles
            };
            const callbacks = {
                // Evento que permitirá saber que el token se creado de forma satisfactoria, es importante que se consuman los datos que de él derivan.
                onCreateTokenSucceeded: function (token) {
                    console.log(token)
                },
                // Evento que permitirá saber que el token se creado de manera incorrecta, es importante que se consuman los datos que de él derivan y se hagan las correciones pertinentes.
                onCreateTokenError: function (error) {
                    console.log(error)
                }
            };

            window.ConektaCheckoutComponents.Card({
                config,
                callbacks,
                //Este componente "allowTokenization" permite personalizar el tokenizador, por lo que su valor siempre será TRUE
                allowTokenization: true,
            })
        }
    }


    const planes = [
        {
            plan: 'Plan Gratuito',
            price: 'Gratis',
            description: 'Nuestra opción gratuita para aquellos que buscan explorar y comenzar con Bienvivir.',
            styles: 'bg-sky text-blue',
            topics: [
                'Tips y documentos limitados.',
                'Acceso restringido a contenido premium.',
                'Funciones básicas de la aplicación.',
                'Sin límite de tiempo de uso.',
                'Publicidad para mantener el servicio gratuito.'
            ]
        },
        {
            plan: 'Plan Básico',
            price: '$69',
            description: 'El Plan Básico es ideal para usuarios regulares que desean más que lo básico.',
            styles: 'bg-danger text-red',
            topics: [
                'Tips y documentos ilimitados, incluyendo conferencias generales.',
                'Acceso sin publicidad.',
                'Todas las funciones básicas de la aplicación.',

            ]
        },
        {
            plan: 'Plan Premium',
            price: '799',
            styles: 'bg-mint text-green',
            description: 'Experimenta lo mejor de Bienvivir con nuestro Plan Premium. Accede a funciones exclusivas y disfruta de un cuidado completo',
            topics: [
                'Tips y documentos limitados.',
                'Una cita al mes de seguimiento psicológico.',
                'Herramientas avanzadas para el seguimiento de citas.',
                'Notificaciones de acuerdos y funcionalidad "Familia".',

            ]
        },
        {
            plan: 'Sesion Extra',
            price: 'Próximamente',
            description: '¡Próximamente! Añade sesiones adicionales según tus necesidades.',
            styles: 'bg-lightorange text-orange',
            topics: [
                'Sesiones flexibles según tu disponibilidad.',
                'Acceso rápido y conveniente a nuestros servicios.',

            ]
        }
    ]




    return (
        <>
            <Renderif isTrue={state.show_agendar_cita}>
                <AgendarCita onSchedule={(cita) => { }} onCancel={() => {
                    setState({ ...state, show_agendar_cita: false })
                }}></AgendarCita>
            </Renderif>


            <div className={`overlay overflow-auto checkout ${state.showCheckOut ? 'd-block' : 'd-none'}`} onClick={(evt) => {
                evt.stopPropagation();
                setState({ ...state, showCheckOut: false })
            }}>
                <div id="conektaIframeContainer" style={{ height: 700 }}></div>
            </div>


            <div className='container-fluid h-100 d-flex'>


                <SideMenu></SideMenu>

                <div className='col hide-scroll'>

                    <div className='d-flex flex-lg-row  bg-white p-2 p-sm-3 '>
                        <div className='d-flex align-items-center'>
                            <div className='input--light-curve'>
                                <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
                                <input placeholder='Busca Tips, Documentos, etc.'></input>
                            </div>
                        </div>
                        <div className='col'></div>

                        <div className='d-flex flex-column flex-md-row align-items-md-center justify-content-end'>

                            <div className='d-flex py-1 py-sm-2 order-0 order-md-1'>
                                <div className='pe-2 cita-button flex-center'>
                                    <div className='bv-cta-curve bv-cta--primary-black bv-icon bv-icon--mid' onClick={() => {
                                        // setState({ ...state, show_agendar_cita: true })
                                        navigate('/client/crear-cita')
                                    }}>
                                        <MdCalendarMonth size={20} className='me-2'></MdCalendarMonth>
                                        Agendar cita
                                    </div>
                                </div>
                                <div className='pe-2'>
                                    <div className='bv-cta bv-cta--outline bv-cta-circle' onClick={() => {
                                        if (state.notifications_menu) {
                                            setState({ ...state, notifications_menu: false })
                                        } else {
                                            setState({ ...state, notifications_menu: true })
                                        }

                                    }}><MdNotificationsNone size={24} color={gray40}></MdNotificationsNone>
                                        <Renderif isTrue={state.notifications_menu}>
                                            <div className='float-menu'>
                                                <div className='h-menu flex-center-left separator-h-bottom p-2'>
                                                    Notificaciones
                                                </div>
                                                <div className='b-menu'>
                                                    <div className='card-notification d-flex separator-h-top'>
                                                        <div className=''>
                                                            <div className='avatar-profile'></div>
                                                        </div>
                                                        <div className='flex-center f-12 p-2'>
                                                            Por el momento no cuentas con notificaciones
                                                        </div>
                                                    </div>
                                                    {/* <div className='card-notification d-flex separator-h-top'>
                                                        <div className=''>
                                                            <div className='avatar-profile'></div>
                                                        </div>
                                                        <div className='flex-center f-12 p-2'>
                                                            El Dr. Raymundo marqueda ha subido tus recuerdos
                                                        </div>
                                                    </div>
                                                    <div className='card-notification d-flex separator-h-top'>
                                                        <div className=''>
                                                            <div className='avatar-profile'></div>
                                                        </div>
                                                        <div className='flex-center f-12 p-2'>
                                                            El Dr. Raymundo marqueda ha subido tus recuerdos
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </Renderif>
                                    </div>
                                </div>

                                <div className='pe-2 me-4 agreements'>
                                    <div className='bv-cta bv-cta--outline bv-cta-circle' onClick={() => {
                                        if (state.agreements_menu) {
                                            setState({ ...state, agreements_menu: false })
                                        } else {
                                            setState({ ...state, agreements_menu: true })
                                        }

                                    }}><FaPeopleGroup size={24} color={gray40}></FaPeopleGroup>
                                        <Renderif isTrue={state.agreements_menu}>
                                            <div className='float-menu'>
                                                <div className='h-menu flex-center-left separator-h-bottom p-2'>
                                                    Acuerdos pendientes
                                                </div>
                                                <div className='b-menu'>
                                                    <div className='card-notification d-flex separator-h-top'>
                                                        <div className='flex-center ms-2'>
                                                            <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                        </div>
                                                        <div className='flex-center f-12 p-2'>
                                                            Por el momento no cuentas con notificaciones
                                                        </div>
                                                    </div>
                                                    {/* <div className='card-notification d-flex separator-h-top'>
                                                        <div className='flex-center ms-2'>
                                                            <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                        </div>
                                                        <div className='flex-center f-12 p-2'>
                                                            Hacer ejercicio
                                                        </div>
                                                    </div>
                                                    <div className='card-notification d-flex separator-h-top'>
                                                        <div className='flex-center ms-2'>
                                                            <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                        </div>
                                                        <div className='flex-center f-12 p-2'>
                                                            Leer
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </Renderif>
                                    </div>
                                </div>

                                <div className='pe-2 px-md-2 flex-center separator-v-left cursor-pointer' onClick={() => {
                                    if (state.profile_menu) {
                                        setState({ ...state, profile_menu: false })
                                    } else {
                                        setState({ ...state, profile_menu: true })
                                    }

                                }}>
                                    <div className='avatar-profile  ms-lg-3'></div>
                                    <div className=''>
                                        <IoIosArrowDown size={18} color={'#000000'}></IoIosArrowDown>

                                    </div>

                                </div>
                                <Renderif isTrue={state.profile_menu}>
                                    <div className='float-menu-profile'>
                                        <div className='b-menu'>
                                            <div className='card-notification flex-center-j-left m-2'>
                                                <div className=''>
                                                    <div className='avatar-profile'></div>
                                                </div>
                                                <div className='p-2'>
                                                    <div className='bold f-14'>
                                                        {user?.firstName} {user?.lastName}
                                                    </div>
                                                    <div className='f-12 text-miperfil bold cursor-pointer' onClick={() => {
                                                        navigate('/client/profile')
                                                    }}>
                                                        Mi perfil
                                                        <IoIosArrowForward size={12} color={primary} className='ms-1'></IoIosArrowForward>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='b-menu'>
                                            <div className='card-notification d-flex separator-h-top cursor-pointer'>
                                                <div className='flex-center ms-2'>
                                                    <GoGear size={15} color={gray40}></GoGear>
                                                </div>
                                                <div className='flex-center f-12 p-2'>
                                                    Configuración
                                                </div>
                                            </div>
                                            <div className='card-notification d-flex separator-h-top cursor-pointer' onClick={() => {
                                                logout();
                                                navigate('/')
                                            }}>
                                                <div className='flex-center ms-2'>
                                                    <CgLogOut size={15} color={gray40} />
                                                </div>
                                                <div className='flex-center f-12 p-2'>
                                                    Cerrar sesión
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Renderif>
                            </div>



                        </div>
                    </div>


                    <div className='container pe-3'>

                        <div className='d-flex flex-column align-items-center mt-4 p-4'>
                            <div className='f-18 bold'>Únete a millones de clientes satisfechos en nuestra plataforma.</div>
                            <div className='f-14 text-gray'>Explora nuestras opciones y elige el plan que mejor se adapte a tu estilo de vida.</div>
                            <div className='my-4'></div>
                        </div>


                        <div className='row'>

                            {
                                planes.map((item, i) => {
                                    return (
                                        <div key={i} className='col ps-4'>
                                            <div className='shadow r-5  h-100 b-100'>
                                                <div className='d-flex flex-column h-100'>



                                                    <div className={`bold px-2 py-3 f-14 ${item.styles}`}>{item.plan.toUpperCase()}</div>

                                                    <div className='p-3'>
                                                        <div className='f-18 bold mt-4'>{item.price} <span className='f-14'>/mes</span></div>
                                                        <div className='f-14  mt-3'>{item.description}</div>


                                                        <div className='d-flex flex-column pt-4'>

                                                            {
                                                                item.topics.map((item, i) => {
                                                                    return (
                                                                        <div key={i} className='d-flex align-items-center'>
                                                                            <div className='bv-icon bv-icon--mid'>
                                                                                <IoMdCheckmarkCircleOutline color='gray' size={22} />
                                                                            </div>
                                                                            <div className='f-14 '>{item}</div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }


                                                        </div>

                                                        <div className='d-block mx-auto'>
                                                            <div className='bv-cta-curve txt-white' onClick={() => {
                                                                // navigate('/client/checkout')

                                                                // setState({...state, showCheckOut:true, rederedCheckOut:true})
                                                                if (i === 3) {
                                                                    return
                                                                }
                                                                switch (i) {
                                                                    case 0:
                                                                        CheckOut(1)
                                                                        break;
                                                                    case 1:
                                                                        CheckOut(0)
                                                                        break;

                                                                    case 2:
                                                                        CheckOut(3)
                                                                        break;

                                                                    default:
                                                                        break;
                                                                }

                                                            }}>
                                                                Seleccionar
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }







                        </div>
                    </div>







                </div>
            </div>
        </>
    )
}



